import { render } from "./Top3Panel.vue?vue&type=template&id=6097dfcf"
import script from "./Top3Panel.vue?vue&type=script&lang=ts"
export * from "./Top3Panel.vue?vue&type=script&lang=ts"

import "./Top3Panel.vue?vue&type=style&index=0&id=6097dfcf&lang=scss"
script.render = render

export default script